import { useNavigation } from '@react-navigation/native';
import { VStack, Box, Text, Button, FlatList } from 'native-base';
import React, { useEffect, useState } from 'react';
import { Dimensions, Image, ImageBackground } from "react-native";
import { getAuth } from 'firebase/auth';
import { doc, getDoc, getFirestore } from 'firebase/firestore';
const windowWidth = Dimensions.get('window').width;

interface MinhaContaScreenProps {
    onSignOut: () => void;
}



const MinhaContaScreen= ({ onSignOut }) => {


    const navigation = useNavigation();
    const [transactions, setTransactions] = useState<
        Array<{ id: string; description: string; value: string }>
    >([]);

    useEffect(() => {
        const fetchUserData = async () => {
            const auth = getAuth();
            const db = getFirestore();
            const user = auth.currentUser;

            if (user) {
                const userRef = doc(db, 'users', user.uid);
                const userSnap = await getDoc(userRef);

                if (userSnap.exists()) {
                    const userData = userSnap.data();

                    const info = [
                        { id: "1", description: "Nome:", value: userData.firstName || '' },
                        { id: "2", description: "E-mail:", value: userData.email || '' },
                        { id: "3", description: "Contato:", value: userData.phoneNumber || '' },
                        { id: "4", description: "button", value: "Voltar" },
                    ];

                    setTransactions(info);
                }
            }
        };

        fetchUserData();
    }, []);

    return (
        <VStack flex={1} bg="gray.100">
            <Box>
                <VStack alignItems="center">
                    <ImageBackground
                        source={{ uri: 'https://taentregue.com.br/imagem/tela_home.png' }}
                        style={{ width: "100%", height: 100 }}
                        resizeMode="cover"
                    >
                        <Image
                            source={{ uri: 'https://taentregue.com.br/imagem/logo.png' }}
                            style={{
                                width: windowWidth,
                                height: windowWidth * 0.1,
                                resizeMode: 'contain',
                                marginTop: 15
                            }}
                        />
                    </ImageBackground>
                </VStack>

                <FlatList
                    data={transactions}
                    keyExtractor={(item) => item.id}
                    renderItem={({ item }) => (
                        item.description === 'button' ? (
                            <Box p={2} borderBottomWidth={1} borderColor="gray.200">
                                <Button colorScheme="lightBlue" onPress={() => navigation.navigate("Home")}>
                                    Voltar
                                </Button>
                            </Box>
                        ) : (
                            <Box p={2} borderBottomWidth={1} borderColor="gray.200">
                                <Text fontSize="sm">{item.description}</Text>
                                <Text fontSize="md" bold color="gray.500">
                                    {item.value}
                                </Text>
                            </Box>
                        )
                    )}
                />
            </Box>
        </VStack>
    );
};

export default MinhaContaScreen;
